
import { Link } from 'react-router-dom';

export default function ProductsHero() {
  return (
    <section className="relative bg-[#1A1A1A] text-white py-20 md:py-32 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="font-['Montserrat'] font-bold text-3xl md:text-5xl lg:text-6xl mb-6 leading-tight">
          Professional-Grade Building Materials
        </h1>
        <p className="text-base md:text-lg lg:text-xl text-gray-300 mb-8 md:mb-10 max-w-3xl mx-auto">
          Every product. Three performance tiers. Choose the grade that matches your project and budget.
        </p>
        <Link
          to="/contact"
          className="block w-full md:w-auto md:inline-flex bg-[#F2C612] text-[#1A1A1A] font-['Montserrat'] font-semibold px-8 py-3 rounded-lg hover:bg-[#d4ad0a] transition-colors whitespace-nowrap cursor-pointer min-h-[48px] flex items-center justify-center text-center"
        >
          Find a Stockist
        </Link>
      </div>
    </section>
  );
}
